import { createContext, useContext } from "react";
import type { CreateLeadLabelInput, LeadLabel } from "@school-sales-ai/shared";

export type LabelsContextValue = {
  allLabels: LeadLabel[];
  assign: (leadId: string, labelId: string) => void;
  unassign: (leadId: string, labelId: string) => void;
  create: (input: CreateLeadLabelInput, onCreated: (label: LeadLabel) => void) => void;
  isCreating: boolean;
};

export const LabelsContext = createContext<LabelsContextValue | null>(null);

/**
 * Label data + actions from the nearest provider. Throws rather than falling
 * back to per-component hooks: a silent fallback is exactly the regression the
 * provider exists to prevent.
 */
export function useLabelsContext(): LabelsContextValue {
  const ctx = useContext(LabelsContext);
  if (!ctx) {
    throw new Error("useLabelsContext must be used inside a <LabelsProvider>");
  }
  return ctx;
}
